import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  data: {
    phone: '',
    office365PhotoUrl: '',
    instagram: '',
    name: '',
    title: '',
    showEmailAddress: true,
    useOffice365Photo: true,
    otherUrl: '',
    urlTitle: '',
    imageType: '',
    bio: '',
    department: '',
    saCloudinaryImages: {},
  },
  signatureHtml: '',
  htmlLoading: false,
  loading: false,
};

const emailSettings = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_STARTED:
    case actionTypes.GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_STARTED:
      return { ...state, loading: true };

    case actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_FAILED:
    case actionTypes.GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_FAILED:
      return { ...state, loading: false };

    case actionTypes.SET_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS:
    case actionTypes.GET_CURRENT_ASSOCIATE_EMAIL_SIGNATURE_SUCCESS: {
      const {
        phone,
        office365PhotoUrl,
        instagram,
        name,
        title,
        showEmailAddress,
        useOffice365Photo,
        otherUrl,
        urlTitle,
        imageType,
        previewTemplate,
        bio,
        department,
        templateData,
        saCloudinaryImages,
      } = payload;

      return {
        ...state,
        loading: false,
        data: {
          phone,
          office365PhotoUrl,
          instagram,
          name,
          title,
          showEmailAddress,
          useOffice365Photo,
          otherUrl,
          urlTitle,
          imageType,
          bio,
          department,
          saCloudinaryImages,
        },
        signatureHtml: previewTemplate,
        signatureData: templateData,
      };
    }

    default:
      return state;
  }
};

export default emailSettings;
